import { Box, Chip, Container, Grid, Typography } from '@mui/material';
import {
  HeroDarkBgColor,
  HeroLightBgColor,
  SectionTitleFontSize,
} from '../HomeView';

const AboutInstructorSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: (t) =>
          t.palette.mode == 'dark' ? HeroDarkBgColor : HeroLightBgColor,
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Text */}
          <Grid item xs={12} md={7}>
            <Typography
              variant="h4"
              fontWeight={700}
              fontSize={SectionTitleFontSize}
            >
              About the Instructor
            </Typography>

            <Typography variant="h5" fontWeight={700}>
              Jim Warwick, Ed.D.
            </Typography>

            <Box
              sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 2, mb: 2 }}
            >
              <Chip
                label="Law Enforcement Veteran"
                color="primary"
                variant="filled"
              />
              <Chip label="Trainer" color="primary" variant="filled" />
              <Chip label="Educator" color="primary" variant="filled" />
            </Box>

            <Typography variant="body1" color="textSecondary" sx={{ mb: 2 }}>
              With more than 26 years in law enforcement, Jim Warwick has
              dedicated his career to helping others survive life-or-death
              situations. As a Senior Weapons and Tactics Instructor, he brings
              deep operational experience in Patrol, K-9, and Special Operations
              Response.
            </Typography>

            <Typography variant="body1" color="textSecondary" sx={{ mb: 2 }}>
              Jim holds a Doctorate in Organizational Learning, Leadership, and
              Innovation, with research focused on active shooter preparedness.
              Since 2006, he has trained thousands of professionals using a
              combination of field-tested strategy and academic rigor.
            </Typography>
          </Grid>

          {/* Headshot */}
          <Grid
            item
            xs={12}
            md={5}
            sx={{ textAlign: { xs: 'center', md: 'right' } }}
          >
            <Box
              component="img"
              src="jim-profile.png"
              alt="Headshot of Jim Warwick"
              sx={{
                width: '100%',
                maxWidth: 360,
                aspectRatio: '3 / 4',
                objectFit: 'cover',
                borderRadius: 2,
                boxShadow: 3,
                bgcolor: 'action.hover',
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutInstructorSection;
